// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"27d33749","453":"8cb34597"}[chunkId] + ".chunk.js";
};